import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/YourStylist/Home_Page";
import Policy from "../pages/YourStylist/Policy";
const YourStylistTemplate = () => {
  return (
    <>
      <div className="bg-[#F0F4FE] min-h-screen overflow-hidden">
        <AppRoutes homePage={HomePage} shippingPage={Policy} />
      </div>
    </>
  );
};

export default YourStylistTemplate;
